export enum PopupTheme {
  'success' = 'success',
  'danger' = 'danger',
}
export enum ButtonColor {
  'default' = 'colorDefault',
  'light' = 'colorLight',
  'alternate' = 'alternate',
  'gray' = 'gray',
  'mediumGray' = 'mediumGray',
  'dark' = 'colorDark',
}

export enum ButtonSize {
  'small' = 'sizeSmall',
  'medium' = 'sizeMedium',
  'mediumLarge' = 'mediumLarge',
  'large' = 'sizeLarge',
}

export enum ButtonType {
  'Button' = 'button',
  'Submit' = 'submit',
}

export enum PartnersPortalInputValueTypes {
  'LAST_4_DIGITS_SSN' = 'LAST_4_DIGITS_SSN',
  'FULL_SSN' = 'FULL_SSN',
  'ASSOCIATE_ID' = 'ASSOCIATE_ID',
  'DECLINE_KEY' = 'DECLINE_KEY',
  'STORE_INVOICE' = 'STORE_INVOICE',
  'TRANSACTION_ID' = 'TRANSACTION_ID',
  'PHONE_NUMBER' = 'PHONE_NUMBER',
  'TOTAL_PURCHASE_AMOUNT' = 'TOTAL_PURCHASE_AMOUNT',
  'CREDIT_CARD' = 'CREDIT_CARD',
  'CREDIT_CARD_CVV' = 'CREDIT_CARD_CVV',
  'CREDIT_CARD_MONTH' = 'CREDIT_CARD_MONTH',
  'CREDIT_CARD_YEAR' = 'CREDIT_CARD_YEAR',
  'CONTRACT_NUMBER' = 'CONTRACT_NUMBER',
  'PURCHASE_DATE' = 'PURCHASE_DATE',
  'USER_NAME' = 'USER_NAME',
  'PASSWORD' = 'PASSWORD',
}

export enum PartnersPortalInputLabelTypes {
  'LAST_4_DIGITS_SSN' = 'Last 4 digits of customer’s SSN',
  'FULL_SSN' = 'FULL_SSN',
  'ASSOCIATE_ID' = 'Associate ID',
  'DECLINE_KEY' = 'Synchrony Decline Key',
  'STORE_INVOICE' = 'Store Invoice No./Transaction ID',
  'TRANSACTION_ID' = 'Store Invoice No./Transaction ID',
  'PHONE_NUMBER' = 'Customer’s Phone Number',
  'TOTAL_PURCHASE_AMOUNT' = 'Total Purchase Amount (including taxes)',
  'CREDIT_CARD' = 'Card Number',
  'CREDIT_CARD_CVV' = 'CVV',
  'CREDIT_CARD_MONTH' = 'CREDIT_CARD_MONTH',
  'CREDIT_CARD_YEAR' = 'CREDIT_CARD_YEAR',
  'CONTRACT_NUMBER' = 'Sunbit Contract Number',
  'PURCHASE_DATE' = 'Purchase Date',
  'USER_NAME' = '',
  'PASSWORD' = '',
}

export enum paymentMethod {
  'visa' = 'VISA',
  'mastercard' = 'MASTER CARD',
  'amex' = 'AMERICAN EXPRESS',
  'discover' = 'DISCOVER',
}
